<template>
  <div id="app">
    <!-- <Names/> -->
    <!-- <Cat/> -->
    <!-- <todo-list /> -->
    <test/>
    <quagga-micha/>
  </div>
</template>

<script>
// import Names from "./components/Names.vue";
// import Cat from "./components/Cat.vue";
// import TodoList from './components/TodoList.vue'
import Test from './components/Test.vue';
import  QuaggaMicha from './components/QuaggaMicha.vue';

export default {
  name: "App",
  components: {
    // Names,
    // Cat
    // TodoList,
    QuaggaMicha,
    Test
  },
};
</script>

<style lang="scss">
</style>
